type VariantSize = {
    pxWidth?: number | null
    pxHeight?: number | null
    cmWidth?: number | null
    cmHeight?: number | null
}

type VariantNode = { size?: VariantSize | null }
type ProductLike = {
    maxSizeX?: number | null // cm
    maxSizeY?: number | null // cm
    variants?: { edges?: Array<{ node?: VariantNode | null } | null> | null } | null
}

export type MaxPx = {
    maxWidthPx: number
    maxHeightPx: number
    source: 'variant_px' | 'variant_cm' | 'product_cm_fallback'
}

function cmToPx(cm: number, dpi: number) {
    return Math.round((cm / 2.54) * dpi)
}

export function getMaxAllowedPixelsFromProduct(product: ProductLike, dpi = 300): MaxPx | null {
    const edges = product?.variants?.edges ?? []
    const sizes: VariantSize[] = edges
        .map(e => e?.node?.size ?? null)
        .filter(Boolean) as VariantSize[]

    const pxCandidates = sizes
        .filter(s => (s.pxWidth ?? 0) > 0 && (s.pxHeight ?? 0) > 0)
        .map(s => ({ w: Number(s.pxWidth), h: Number(s.pxHeight) }))

    if (pxCandidates.length) {
        const best = pxCandidates.reduce((a, b) => (b.w * b.h > a.w * a.h ? b : a))
        return { maxWidthPx: best.w, maxHeightPx: best.h, source: 'variant_px' }
    }

    const cmCandidates = sizes
        .filter(s => (s.cmWidth ?? 0) > 0 && (s.cmHeight ?? 0) > 0)
        .map(s => ({ w: cmToPx(Number(s.cmWidth), dpi), h: cmToPx(Number(s.cmHeight), dpi) }))

    if (cmCandidates.length) {
        const best = cmCandidates.reduce((a, b) => (b.w * b.h > a.w * a.h ? b : a))
        return { maxWidthPx: best.w, maxHeightPx: best.h, source: 'variant_cm' }
    }

    if ((product.maxSizeX ?? 0) > 0 && (product.maxSizeY ?? 0) > 0) {
        return {
            maxWidthPx: cmToPx(Number(product.maxSizeX), dpi),
            maxHeightPx: cmToPx(Number(product.maxSizeY), dpi),
            source: 'product_cm_fallback',
        }
    }

    return null
}